import { createAction, props } from '@ngrx/store';
import {
    AccessControlClientTemplate,
    AccessControlContractCompanyTemplate
} from 'src/app/shared/models/access-control-contract-company-template.model';
import {
    AccessControlClientTemplateModel,
    AccessControlContractTemplateModel
} from '../../models/access-control-template.model';

export const loadAccessControlContractCompanyTemplates = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Load Access Control Contract Company Templates'
);

export const loadAccessControlContractCompanyTemplatesSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Templates Success',
    props<{ contractTemplates: AccessControlContractCompanyTemplate[] }>()
);

export const loadAccessControlContractCompanyTemplatesFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Templates Fail',
    props<{ error: any }>()
);

export const loadAccessControlClientTemplates = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Load Access Control Client Templates'
);

export const loadAccessControlClientTemplatesSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Templates Success',
    props<{ clientTemplates: AccessControlClientTemplate[] }>()
);

export const loadAccessControlClientTemplatesFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Templates Fail',
    props<{ error: any }>()
);

export const validateAccessControlTemplateName = createAction(
    '[ACCESS CONTROL TEMPLATE DIALOG COMPONENT] Validate Access Control Template Name',
    props<{ templateName: string; templateType: number; resetValidation?: boolean }>()
);

export const validateAccessControlTemplateNameSuccess = createAction(
    '[ACCESS CONTROL API] Validate Access Control Template Name Success',
    props<{ contractTemplateNameExists: boolean; resetValidation?: boolean }>()
);

export const validateAccessControlTemplateNameFail = createAction(
    '[ACCESS CONTROL API] Validate Access Control Template Name Fail',
    props<{ error: any }>()
);

export const saveAccessControlContractCompanyTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Save Access Control Contract Company Template',
    props<{ templateInformation: AccessControlContractTemplateModel }>()
);

export const saveAccessControlTemplateContractCompanySuccess = createAction(
    '[ACCESS CONTROL API] Save Access Control Template Contract Company Success'
);

export const saveAccessControlContractCompanyTemplateFail = createAction(
    '[ACCESS CONTROL API] Save Access Control Template Contract Company Fail',
    props<{ error: any }>()
);

export const saveAccessControlClientTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Save Access Control Client Template',
    props<{ templateInformation: AccessControlClientTemplateModel }>()
);

export const saveAccessControlClientTemplateSuccess = createAction(
    '[ACCESS CONTROL API] Save Access Control Template Client Success'
);

export const saveAccessControlClientTemplateFail = createAction(
    '[ACCESS CONTROL API] Save Access Control Template Client Fail',
    props<{ error: any }>()
);

export const resetAccessControlTemplateNameValidation = createAction(
    '[ACCESS CONTROL TEMPLATE DIALOG COMPONENT] Reset Validation Flag'
);

export const updateAccessControlContractCompanyTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Update Access Control Contract Company Template',
    props<{ templateInformation: AccessControlContractTemplateModel }>()
);

export const updateAccessControlTemplateContractCompanySuccess = createAction(
    '[ACCESS CONTROL API] Update Access Control Template Contract Company Success',
    props<{ templateId: number }>()
);

export const updateAccessControlContractCompanyTemplateFail = createAction(
    '[ACCESS CONTROL API] Update Access Control Template Contract Company Fail',
    props<{ error: any }>()
);

export const updateAccessControlClientTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Update Access Control Client Template',
    props<{ templateInformation: AccessControlClientTemplateModel }>()
);

export const updateAccessControlClientTemplateSuccess = createAction(
    '[ACCESS CONTROL API] Update Access Control Template Client Success',
    props<{ templateId: number }>()
);

export const updateAccessControlClientTemplateFail = createAction(
    '[ACCESS CONTROL API] Update Access Control Template Client Fail',
    props<{ error: any }>()
);
